/**
 * @generated SignedSource<<8ed38d65ab770440e5c993ceacc51f57>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type seriesWidgetEntrypointHeadlineArticle$data = {
  readonly seriesContainer: {
    readonly headline: string | null | undefined;
    readonly " $fragmentSpreads": FragmentRefs<"entityLink">;
  } | null | undefined;
  readonly " $fragmentType": "seriesWidgetEntrypointHeadlineArticle";
};
export type seriesWidgetEntrypointHeadlineArticle$key = {
  readonly " $data"?: seriesWidgetEntrypointHeadlineArticle$data;
  readonly " $fragmentSpreads": FragmentRefs<"seriesWidgetEntrypointHeadlineArticle">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "seriesWidgetEntrypointHeadlineArticle",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Article",
      "kind": "LinkedField",
      "name": "seriesContainer",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "entityLink"
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "headline",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Article",
  "abstractKey": null
};

(node as any).hash = "a7e7cf72e05cb833d237db7ed0c9c494";

export default node;
